/** @jsxImportSource @emotion/react */
import { useMerchantApplicationContext } from 'contexts';
import PostApplicationSubmissionModule from 'modules/activation/post-application-submission';
import { FC, useEffect } from 'react';
import { MerchantApplicationStatus } from 'types/responses/activation';
import { getGreeting, logEvent } from 'utils';
import * as styles from './ActivationDashboard.styles';
import { FaqCard } from './FaqCard';
import { FinaliseAccountCard } from './FinaliseAccountCard';
import type { ActivationDashboardProps } from './types';
import { PageAction } from 'enums';

export const ActivationDashboardModule: FC<ActivationDashboardProps> = ({
  firstName = '',
  completedCount,
  totalCount,
  steps,
  applicationStatus,
  salesforceSdocContractUrl,
}) => {
  const { merchantApplicationId, isPostSubmission } =
    useMerchantApplicationContext();
  const postSubmission = isPostSubmission();

  const firstNameDisplay = firstName ?? '';

  useEffect(() => {
    if (postSubmission) {
      logEvent(PageAction.merchantOnboardingPVPostSubmission, {
        merchantApplicationId,
        applicationStatus,
      });
    } else {
      logEvent(PageAction.merchantOnboardingPVActivationDashboard, {
        merchantApplicationId,
        completedCount,
        totalCount,
      });
    }
  }, [merchantApplicationId]);

  return (
    <div css={styles.activationDashboardRoot}>
      <div css={styles.activationDashboardContent}>
        {!postSubmission && (
          <>
            <h1 className="title3" css={styles.welcomeHeading}>
              Welcome {firstNameDisplay}
            </h1>

            <FinaliseAccountCard
              completedCount={completedCount}
              totalCount={totalCount}
              steps={steps}
            />
          </>
        )}

        {postSubmission && (
          <>
            {applicationStatus !== MerchantApplicationStatus.Declined && (
              <h1 className="title4" css={styles.welcomeHeading}>
                {`${getGreeting()} ${firstNameDisplay}`}
              </h1>
            )}

            <PostApplicationSubmissionModule
              status={applicationStatus}
              salesforceSdocContractUrl={salesforceSdocContractUrl}
            />
          </>
        )}

        <FaqCard applicationStatus={applicationStatus} />
      </div>
    </div>
  );
};

export default ActivationDashboardModule;
